import { styled } from 'styled-components';
import { SPText, SUl } from '~/components/styles/styles';
import { formatText } from '~/utils/common/utils';

type IProps = {};

type TProps = IProps;

export function RulesSoloContent({}: TProps) {
  return (
    <Container>
      <SPText>{`Dans le mode Solo, votre objectif est de traverser toutes les cases du plateau jusqu'à la ligne d’arrivée.`}</SPText>
      <SDiv>
        <SPText $textDecoration="underline">Déroulement de la partie</SPText>
        <SDiv $withPaddingLeft>
          <SPText>
            À chaque case, vous devez répondre à trois questions sur un thème
            donné.
          </SPText>
          <SPText>{formatText('Selon vos réponses :')}</SPText>
          <SUl $margin="0 0 0 30px">
            <li>
              <SPText>3 bonnes réponses → vous avancez de deux cases.</SPText>
            </li>
            <li>
              <SPText>
                2 bonnes réponses → vous avancez d’une case.
              </SPText>
            </li>
            <li>
              <SPText>
                1 bonne réponse → vous ne bougez pas.
              </SPText>
            </li>
            <li>
              <SPText>
                Aucune bonne réponse → vous reculez d’une case.
              </SPText>
            </li>
          </SUl>
        </SDiv>
      </SDiv>

      <SDiv>
        <SPText $textDecoration="underline">Classement</SPText>
        <SDiv $withPaddingLeft>
          <SPText>
            - À chaque amélioration de votre score, votre position dans le
            classement progresse.
          </SPText>
          <SPText>
            {formatText(
              '- Comparez votre performance avec celle des autres joueurs pour viser le sommet !'
            )}
          </SPText>
        </SDiv>
      </SDiv>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const SDiv = styled.div<{ $withPaddingLeft?: boolean }>`
  padding-left: ${({ $withPaddingLeft }) => ($withPaddingLeft ? '20px' : '0')};
  width: 100%;

  @media screen and (max-height: 800px) {
    padding-left: ${({ $withPaddingLeft }) =>
      $withPaddingLeft ? '15px' : '0'};
  }

  @media screen and (max-width: 450px) {
    padding-left: ${({ $withPaddingLeft }) =>
      $withPaddingLeft ? '10px' : '0'};
  }
  @media screen and (max-height: 450px) {
    padding-left: ${({ $withPaddingLeft }) =>
      $withPaddingLeft ? '10px' : '0'};
  }
`;
